import axios from "axios";

import axiosTokenService from "./axiosTokenService";

import { login_url } from "./Configuration";

const cloud_url = "https://api.dev.herb.apcfss.in/dms/user-defined-path/";

class DesService {
  loginDetails(params) {
    return axios.post(login_url + "userLogin", params);
  }

  userLogout(params) {
    return axiosTokenService.post(login_url + "Logout", params);
  }

  getModuleData(params) {
    return axiosTokenService.post(login_url + "modulelogin", params);
  }

  getCaptcha() {
    return axios.get(login_url + "api/captcha");
  }

  getswitch(params) {
    return axiosTokenService.post(login_url + "switchModule", params);
  }

  changepassword(params) {
    return axiosTokenService.post(login_url + "changepasswords", params);
  }

  //  hrmsempdata(params) {
  //   return axios.post(login_url + "api/hrmsempdata", params);
  // }

  //  sendotp(params) {
  //   return axios.post(login_url+"api/sendotp", params);
  // }

  // verifyotp(params) {
  //   return axios.post(login_url+"api/verifyotp", params);
  // }

  //  pooptionformupload(params) {
  //   return axios.post(login_url+"api/pooptionformupload", params);
  // }
}

export default new DesService();
